import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SlickSlider from 'react-slick'
import _ from 'lodash'

/**
 * Prevent SlickSlider updates as it breaks .slickGoTo(...) animations
 * * https://github.com/akiran/react-slick/issues/708
 * * Slick manages it's own state, so this makes sense too
 **/
export default class ShouldNotUpdateSlickSlide extends Component {
	constructor() {
		super()
		this.shouldComponentUpdate = _.constant(false)
	}

	render() {
		return (
			<SlickSlider ref={this.props.refr} {...this.props}>
				{this.props.children}
			</SlickSlider>
		)
	}
}
ShouldNotUpdateSlickSlide.propTypes = {
	refr: PropTypes.func.isRequired,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
		.isRequired
}



// WEBPACK FOOTER //
// ./src/components/ShouldNotUpdateSlickSlider.js